import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import transactionService from "./transactionService";
import { flashMessage as flash } from "./../../../utils/flash/index";


const initialState = {
    isLoading: false,
    isSuccess: false,
}


export const transactionSlice = createSlice({
    name: "transaction",
    initialState,
    reducers: {
        resetTransactionStatus: (state) => {
            state.isSuccess = false;
        },
        resetTransaction: (state) => initialState
    },
    extraReducers: (builder) => {
        builder
            // Make Payment 
            .addCase(makePayment.pending, (state) => {
                state.pending = true;
                flash("info", "Processing Payment...");
            })
            .addCase(makePayment.fulfilled, (state, action) => {
                state.pending = false;
                if (!action.payload.errors) {
                    state.isSuccess = true;
                    flash("success", action.payload.message);
                } else if (typeof action.payload.errors == "string") {
                    flash("error", action.payload.errors);
                } else {
                    let key = Object.keys(action.payload.errors)[0];
                    let message = action.payload.errors[key][0];
                    flash("error", message);
                }
            })
            .addCase(makePayment.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            // Make Savings Payment 
            .addCase(makeSavingsPayment.pending, (state) => {
                state.pending = true;
                flash("info", "Processing Payment...");
            })
            .addCase(makeSavingsPayment.fulfilled, (state, action) => {
                state.pending = false;
                if (!action.payload.errors) {
                    state.isSuccess = true;
                    flash("success", action.payload.message);
                } else if (typeof action.payload.errors == "string") {
                    flash("error", action.payload.errors);
                } else if (action.payload.errors) {
                    flash("error", action.payload.errors);
                  } else {
                    let key = Object.keys(action.payload.errors)[0];
                    let message = action.payload.errors[key][0];
                    flash("error", message);
                  }
                })
                .addCase(makeSavingsPayment.rejected, (state, action) => {
                  state.pending = false;
                  state.isError = true;
                  flash("error", 'Amount is lower than the cover to be paid');                
            })
            // Reverse Transaction 
            .addCase(reverseTransaction.pending, (state) => {
                state.pending = true;
                flash("info", "Reversing Payment...");
            })
            .addCase(reverseTransaction.fulfilled, (state, action) => {
                state.pending = false;
                if (!action.payload.errors) {
                    state.isSuccess = true;
                    flash("success", action.payload.message);
                } else if (typeof action.payload.errors == "string") {
                    flash("error", action.payload.errors);
                } else {
                    let key = Object.keys(action.payload.errors)[0];
                    let message = action.payload.errors[key][0];
                    flash("error", message);
                }
            })
            .addCase(reverseTransaction.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            // Reverse Transaction 
            .addCase(reverseSavingsTransaction.pending, (state) => {
                state.pending = true;
                flash("info", "Reversing Payment...");
            })
            .addCase(reverseSavingsTransaction.fulfilled, (state, action) => {
                state.pending = false;
                if (!action.payload.errors) {
                    state.isSuccess = true;
                    flash("success", action.payload.message);
                } else if (typeof action.payload.errors == "string") {
                    flash("error", action.payload.errors);
                } else {
                    let key = Object.keys(action.payload.errors)[0];
                    let message = action.payload.errors[key][0];
                    flash("error", message);
                }
            })
            .addCase(reverseSavingsTransaction.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
    }
})

// Make Payment
export const makePayment = createAsyncThunk(
  "/transaction/makePayment",
  async (data, thunkAPI) => {
    try {
      return await transactionService.makePayment(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// Make Savings Payment
export const makeSavingsPayment = createAsyncThunk(
  "/transaction/makeSavingsPayment",
  async (data, thunkAPI) => {
    try {
      return await transactionService.makeSavingsPayment(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// Reverse Transaction
export const reverseTransaction = createAsyncThunk(
  "/transaction/reverseTransaction",
  async (data, thunkAPI) => {
    try {
      return await transactionService.reverseTransaction(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// Reverse Savings Transaction
export const reverseSavingsTransaction = createAsyncThunk(
  "/transaction/reverseSavingsTransaction",
  async (data, thunkAPI) => {
    try {
      return await transactionService.reverseSavingsTransaction(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const { resetTransaction, resetTransactionStatus } = transactionSlice.actions;
export default transactionSlice.reducer;